import { VIcon, VMenu } from "vuetify/components";
import type { Delivery } from "~/entities/Delivery";
import AtomsMenuPopup from "~/components/Atoms/MenuPopup.vue";
import { getDeliveryStatus, type DeliveryStatus } from "~/interfaces/IDeliveryRepository";

type handleActionType = (val: { text: string; value: any }, item: Delivery) => void;

export const tableHeaders = (handleAction: handleActionType) => {
  return [
    // sp row 1
    {
      label: "",
      key: "name",
      hideTitleSp: true,
      sortable: false,
      align: "left",
      width: 35,
      spAlign: "left",
      spWidth: 90,
      render: (item: Delivery) => {
        return h("div", { class: "w-100 text-left" }, item.name);
      },
    },
    // sp row 2
    {
      label: "配信方法",
      key: "delivery_method",
      sortable: false,
      align: "center",
      width: 20,
      spAlign: "center",
      spWidth: 100 / 2,
      render: (item: Delivery) => {
        const methods = [];
        if (featureBulkDeliveryDm() && item.isSendDm) {
          methods.push("DM");
        }
        if (item.isSendMail) {
          methods.push("メール");
        }
        return methods.join(", ");
      },
    },
    // sp row 2
    {
      label: "配信日",
      key: "schedule_date_time",
      sortable: false,
      align: "center",
      width: 25,
      spAlign: "center",
      spWidth: 100 / 2,
      render: (item: Delivery) => {
        if (item.status === "SENT") {
          return getDeliverySchedule(item.sentDateTime);
        }
        if (item.status === "SENDING") {
          return "配信処理中";
        }
        if (item.status === "RUNNING") {
          if (item.isImmediateDelivery) {
            return "配信準備中";
          } else {
            return h("div", [
              h("div", { class: "text-center" }, "配信準備中"),
              h("div", getDeliverySchedule(item.scheduleDateTime)),
            ]);
          }
        }
        if (item.status === "STOP") {
          return "配信停止中";
        }
        if (item.status === "DRAFT") {
          return "下書き";
        }
        if (item.status === "ABORTED") {
          return "配信エラー";
        }
        return "不明なエラー";
      },
    },
    // sp row 3
    {
      label: "配信数",
      key: "send_count",
      sortable: false,
      align: "center",
      width: 10,
      spAlign: "center",
      spWidth: 100 / 2,
      render: (item: Delivery) => {
        return item.result?.sendCount || 0;
      },
    },
    // sp row 3
    {
      label: "ステータス",
      key: "status",
      sortable: false,
      align: "center",
      width: 10,
      spAlign: "center",
      spWidth: 100 / 2,
      render: (item: Delivery) => {
        const color: Record<string, string> = {
          RUNNING: "text-white",
          STOP: "text-red",
          DRAFT: "text-blue",
        };
        const views = [];
        if (item.status === "SENT") {
          views.push(h("span", { class: "text-blue text-center text-caption" }, "✔"));
        }
        views.push(h("span", { class: color[item.status] || "" }, getDeliveryStatus(item.status as DeliveryStatus)));
        return views;
      },
    },
    // sp row 1
    {
      label: "",
      key: "action",
      sortable: false,
      align: "center",
      width: 15,
      spAlign: "center",
      spWidth: 10,
      render: (item: Delivery) => {
        const status = item.status;
        const items = [
          { text: "送信内容を見る", value: "view-item", disabled: false, hide: status === "DRAFT" },
          { text: "変更する", value: "edit-item", disabled: status === "SENT", hide: status === "DRAFT" },
          { text: "複製する", value: "copy-item", disabled: false, hide: false },

          {
            text: status === "STOP" ? "稼働する" : "停止する",
            value: "status-item",
            disabled: status === "SENT",
            hide: status === "DRAFT",
          },

          { text: "下書き編集する", value: "edit-item", disabled: false, hide: status !== "DRAFT" },
          { text: "削除する", value: "delete-item", disabled: false, hide: false },
        ];

        return h(
          VMenu,
          { location: "bottom" },
          {
            activator: ({ props }: any) => h(VIcon, { icon: "$mdiDotsVertical", ...props }),
            default: () =>
              h(AtomsMenuPopup, {
                list: items.filter(item => !item.hide),
                "onUpdate:selected": (val: any) => handleAction(val, item),
              }),
          },
        );
      },
    },
  ];
};

export const spRows = () => {
  return [
    [{ key: "name" }, { key: "action" }],
    [{ key: "delivery_method" }, { key: "schedule_date_time" }],
    [{ key: "send_count" }, { key: "status" }],
  ];
};
